import { Input } from '../ui/input';
import { CardContent } from '../ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '../ui/form';
import * as z from 'zod';

export const settingsFormSchema = z.object({
  enrollmentLimit: z.string().min(1, {
    message: "Enrollment limit is required.",
  }),
  certificate: z.string().min(1, {
    message: "Certificate template is required.",
  }),
});

export type SettingsFormValues = z.infer<typeof settingsFormSchema>;

interface SettingsTabProps {
  form: any;
  categories? :any;
}

const SettingsTab = ({ form }: SettingsTabProps) => {
  return (
    <CardContent className="space-y-6 pt-2">
      <Form {...form}>
        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <FormField
            control={form.control}
            name="enrollmentLimit"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Enrollment Limit</FormLabel>
                <FormControl>
                  <Input
                    type="number"
                    defaultValue={0}
                    placeholder="Enter maximum number of students"
                    min="1"
                    {...field}
                  />
                </FormControl>
                <FormDescription className="text-xs text-gray-500">
                  Leave empty for unlimited enrollments
                </FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="certificate"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Certificate Template</FormLabel>
                <Select
                  onValueChange={field.onChange}
                  defaultValue={field.value}
                  value={field.value}
                >
                  <FormControl>
                    <SelectTrigger>
                      <SelectValue placeholder="Select certificate template" />
                    </SelectTrigger>
                  </FormControl>
                  <SelectContent>
                    <SelectItem value="default">Default Template</SelectItem>
                    <SelectItem value="professional">Professional</SelectItem>
                    <SelectItem value="minimal">Minimal</SelectItem>
                    <SelectItem value="none">No Certificate</SelectItem>
                  </SelectContent>
                </Select>
                <FormMessage />
              </FormItem>
            )}
          />
        </form>
      </Form>
    </CardContent>
  );
};

export default SettingsTab;